export default __webpack_public_path__ + "static/media/Ballroll_00239.9c1492b9.png";